var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"div",staticClass:"c-split-str"},_vm._l((_vm.strArr),function(str,i){return _c('div',{staticClass:"c-split-str__typo",class:_vm.classnames(i)},[_c('span',{class:_vm.classnames(i),domProps:{"innerHTML":_vm._s(str)}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }